// extracted by mini-css-extract-plugin
module.exports = {"container":"_06665af","optionsGroup":"_6196a21","mainTitle":"_3583488","optionWrapper":"_bb0efc5","optionText":"_381fc38","optionIcon":"_af4465c"};